export const GET_PLC_SAFETY_TRIGGERS = 'GET_PLC_SAFETY_TRIGGERS';
export const GET_PLC_SAFETY_TRIGGERS_SUCCESS = 'GET_PLC_SAFETY_TRIGGERS_SUCCESS';
export const GET_PLC_SAFETY_TRIGGERS_ERROR = 'GET_PLC_SAFETY_TRIGGERS_ERROR';
